import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderComponent} from "../../order-manager/order/order.component";
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';


@Component({
    selector: 'app-approve-order',
    templateUrl: './approve-order.component.html',
    styleUrls: ['./approve-order.component.css'],
    standalone: false
})
export class ApproveOrderComponent {

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<OrderComponent>,
      public nav: NavBarComponent,
  ) {}

    cancelApproval() {
    this.dialogRef.close(false);
  }
    approveOrder() {
      this.dialogRef.close(true);
      this.nav.toggleLoading(true);
  }
}

